import { AuthPermissionModel } from './authPermission.model';

export class AuthUserModel {
  public id: number = null;
  public login: string = null;
  public name: string = null;
  public firstName: string = null;
  public email: string = null;
  public admin: boolean;
  public superAdmin: boolean;
  public secondary = false;

  public permissions: AuthPermissionModel[] = [];

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
